import styled from "styled-components";

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
`;

export default ContentContainer;
